var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table" }, [
    _c("div", { staticClass: "table__wrap" }, [
      _c("table", { staticClass: "table__table" }, [
        _vm.header !== null
          ? _c("thead", [
              _c(
                "tr",
                { staticClass: "table__row table__row--header" },
                _vm._l(_vm.header, function (col) {
                  return _c(
                    "th",
                    { staticClass: "table__col table__col--header" },
                    [_c("span", [_vm._v(_vm._s(col.val))])]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.rows, function (row) {
            return _c(
              "tr",
              { staticClass: "table__row" },
              _vm._l(row, function (col) {
                return _c("td", { staticClass: "table__col" }, [
                  _c("span", [_vm._v(_vm._s(col.val))]),
                  _vm._v(" "),
                  col.isMarked
                    ? _c("span", { staticClass: "table__badge" })
                    : _vm._e(),
                ])
              }),
              0
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }